import { Switchboard } from "../../lib/events";
import { ThematicLayer } from "../layers/server/ThematicLayer";
export class ThematicLayerBox {
    constructor(opts) {
        this.header = $();
        this.body = $();
        this.layers = [];
        this.broadcaster = Switchboard.get_emitter("THEMATIC");
        this.render_index = opts.render_index;
        this.ui_index = opts.ui_index;
    }
    add_layers(layers) {
        this.layers = layers.filter(this.filter);
        this.build_ui();
    }
    filter(l) {
        return l instanceof ThematicLayer;
    }
    build_ui() {
        if (this.layers.length == 0) {
            this.header = $('<span/>');
            return $('<div class="layerType thematic"></div>');
        }
        this.header = $('<div class="header">Thematic</div><hr class="layerbox-hr" />');
        const $thematicDiv = $('<div class="layerType thematic"></div>');
        const $thematicLegend = $("#thematicbox").html("");
        this.layers.forEach(layer => {
            layer.ui
                .map(ui => {
                ui.find(":input").on('click', (_) => this.broadcaster.emit('action', this.layers.filter(l => l.visible).length));
                return ui;
            })
                .map(ui => $thematicDiv.append(ui))
                .map((_) => $thematicLegend.append(layer.legend_ui));
        });
        this.body = $thematicDiv;
    }
}
